import { RemoteOpenDanfe } from '@/data/usecases'
import { makeAxiosHttpClient } from '@/main/factories/http'
import { OpenDanfe } from '@/domain/usecases'
import env from '@/main/config/env'

export const makeOpenDanfe = (): OpenDanfe => {
  const url = env.API_URL
  const httpClient = makeAxiosHttpClient<string>()

  return new RemoteOpenDanfe(url, httpClient)
}
